import { useTranslation } from "react-i18next";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnCard from "../common/adnCard/AdnCard";
import AdnTable from "../common/adnTable/AdnTable";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import AdnButton from "../common/adnButton/AdnButton";
import {
  Collapse,
  Row,
  Col,
  Badge,
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
} from "antd";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnInput from "../common/adnInput/AdnInput";
import { BellOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppRoutes } from "../../AppRoutes";
import { Link } from "react-router-dom";
import {
  MonthlyStatus,
  getFollowUpEventStatus,
} from "../common/GeneralConfigurations";
import { updateEmployeeFollowUpEventNotes } from "../../api/EmployeeFollowUpEventApi";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { useState } from "react";
import "./EmployeeFollowUpEventMonthlyListForm.css";

const { Panel } = Collapse;

export const EmployeeFollowUpEventMonthlyListForm = ({
  title,
  loading,
  columns,
  dataPrevious,
  dataCurrent,
  dataNext,
  currentPageCurrent,
  currentPageNext,
  currentPagePrevious,
  handleChangePageCurrent,
  handleChangePageNext,
  handleChangePagePrevious,
  totalRecordsCurrent,
  totalRecordsNext,
  totalRecordsPrevious,
  totalRecordsCurrentBanner,
  totalRecordsPreviousBanner,
  totalRecordsNextBanner,
  handleOrderListCurrent,
  handleOrderListNext,
  handleOrderListPrevious,
  handleEventStatusChange,
  handleEventTypeChange,
  handleEmployeeSearchChange,
  handleManagerChange,
  handleAssignedToChange,
  assignedToList,
  managersList,
  eventTypeOptions,
  form,
  cancelEventVisible,
  setCancelEventVisible,
  handleCancelEventFinish,
  unresolvedModalVisible,
  setUnresolvedModalVisible,
  unresolvedEmployee,
  confirmAssignPerson,
  eventEmployeeId,
  eventAssignedToId,
  employeeNamePrevious,
  assignedToNamePrevious,
  managerNamePrevious,
  eventTypePrevious,
  statusPrevious,
  employeeNameCurrent,
  assignedToNameCurrent,
  managerNameCurrent,
  eventTypeCurrent,
  statusCurrent,
  employeeNameNext,
  assignedToNameNext,
  managerNameNext,
  eventTypeNext,
  statusNext,
  isUserRH,
  handleNotifyAssignedPeople,
  handleContractTypeChange,
  contractTypeOptions,
  contractTypePrevious,
  contractTypeCurrent,
  contractTypeNext,
}) => {
  const { t } = useTranslation();
  const followUpEventStatuOptions = getFollowUpEventStatus();

  const [selectedMonth, setSelectedMonth] = useState(MonthlyStatus.Current);

  const onUpdateEmployeeFollowUpNotes = async (values) => {
    await updateEmployeeFollowUpEventNotes({ id: values.id, note: values.note })
      .then((res) => {
        if (res.status === 200) {
          AdnMessageSuccess(t("followUpEventForm.messages.notesSavedSuccess"));
        } else if (res && res.data && res.data.errors) {
          res.data.errors.map((e) => {
            AdnMessageError(e.message);
          });
        } else {
          AdnMessageError(t("followUpEventForm.messages.errorSavingNotes"));
        }
      })
      .catch(() => {
        AdnMessageError(t("followUpEventForm.messages.errorSavingNotes"));
      });
  };

  const setBackgroundColor = (record) => {
    let className = record.resignationDate == null ? "" : "employee-resigned";

    className =
      className === ""
        ? record.hasCriticalSituation === true
          ? "employee-criticalSituation"
          : ""
        : className;

    className =
      className === ""
        ? moment(record.referenceDate).add(30, "d") < moment(moment()) &&
          (record.status === 0 || record.status === 1)
          ? "lateEventRow"
          : ""
        : className;

    return className;
  };

  //Retirar daqui
  const badgeMaxNumber = 1000;

  const handleMonthChange = (monthStatus) => {
    setSelectedMonth(monthStatus);
  };

  return (
    <>
      <AdnPageTitle title={title} />
      <div className="monthly-event-div">
        <AdnCard className="month-tab-card">
          <Row justify="end">
            <Col
              className={`tab-system ${
                selectedMonth === MonthlyStatus.Previous ? "selected" : ""
              }`}
            >
              <Badge
                color="#F3983B"
                count={totalRecordsPreviousBanner}
                overflowCount={badgeMaxNumber}
              >
                <AdnButton
                  handleClick={() => handleMonthChange(MonthlyStatus.Previous)}
                  text={t("followUpEventForm.months.previous")}
                />
              </Badge>
            </Col>
            <Col
              className={`tab-system ${
                selectedMonth === MonthlyStatus.Current ? "selected" : ""
              }`}
            >
              <Badge
                color="#F3983B"
                count={totalRecordsCurrentBanner}
                overflowCount={badgeMaxNumber}
              >
                <AdnButton
                  handleClick={() => handleMonthChange(MonthlyStatus.Current)}
                  text={t("followUpEventForm.months.current")}
                />
              </Badge>
            </Col>
            <Col
              className={`tab-system ${
                selectedMonth === MonthlyStatus.Next ? "selected" : ""
              }`}
            >
              <Badge
                color="#F3983B"
                count={totalRecordsNextBanner}
                overflowCount={badgeMaxNumber}
              >
                <AdnButton
                  handleClick={() => handleMonthChange(MonthlyStatus.Next)}
                  text={t("followUpEventForm.months.next")}
                />
              </Badge>
            </Col>
          </Row>
        </AdnCard>
        <AdnCard loading={loading}>
          {/*Change table by selected month*/}
          {selectedMonth === MonthlyStatus.Previous ? (
            <>
              <Row gutter={12} className="filterRow" justify="end">
                <Col
                  className="monthlyNameFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnAutoComplete
                    placeholder={t(
                      "followUpEventForm.placeholders.employeeName"
                    )}
                    handleSearch={(value) =>
                      handleEmployeeSearchChange(value, "previous")
                    }
                    defaultValue={employeeNamePrevious}
                    resultList={[]}
                    valueId="name"
                    allowClear={true}
                  />
                </Col>
                <Col
                  className="monthlyAssignedFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="assignedToName"
                    placeholder={t(
                      "followUpEventForm.placeholders.assignedToName"
                    )}
                    options={assignedToList}
                    allowClear={true}
                    valueIsId={false}
                    defaultValue={
                      assignedToNamePrevious !== ""
                        ? assignedToNamePrevious
                        : null
                    }
                    handleChange={(value) =>
                      handleAssignedToChange(value, "previous")
                    }
                  />
                </Col>
                <Col
                  className="monthlyManagerFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="managerName"
                    placeholder={t(
                      "followUpEventForm.placeholders.managerName"
                    )}
                    options={managersList}
                    allowClear={true}
                    valueIsId={false}
                    defaultValue={
                      managerNamePrevious !== "" ? managerNamePrevious : null
                    }
                    handleChange={(value) =>
                      handleManagerChange(value, "previous")
                    }
                  />
                </Col>
                <Col
                  className="monthlyEventTypeFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="eventType"
                    placeholder={t("followUpEventForm.placeholders.eventType")}
                    options={eventTypeOptions}
                    allowClear={true}
                    defaultValue={
                      eventTypePrevious !== "" ? eventTypePrevious : null
                    }
                    handleChange={(value) =>
                      handleEventTypeChange(value, "previous")
                    }
                  />
                </Col>
                <Col
                  className="monthlyEventStatusFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="eventStatus"
                    placeholder={t(
                      "followUpEventForm.placeholders.eventStatus"
                    )}
                    options={followUpEventStatuOptions}
                    defaultValue={statusPrevious !== "" ? statusPrevious : null}
                    allowClear={true}
                    handleChange={(value) =>
                      handleEventStatusChange(value, "previous")
                    }
                  />
                </Col>
                <Col
                  className="monthlyEventStatusFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="contractType"
                    placeholder={t(
                      "followUpEventForm.placeholders.contractType"
                    )}
                    options={contractTypeOptions}
                    defaultValue={
                      contractTypePrevious !== "" ? contractTypePrevious : null
                    }
                    allowClear={true}
                    valueIsId={false}
                    handleChange={(value) =>
                      handleContractTypeChange(value, "previous")
                    }
                  />
                </Col>
              </Row>

              <Row justify="end" style={{ gap: 12 }}>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.resigned")}
                    <div className="employee-resigned-Dot dot"></div>
                  </div>
                </Col>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.criticalSituation")}
                    <div className="employee-criticalSituation-Dot dot"></div>
                  </div>
                </Col>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.lateEvent")}
                    <div className="lateEventRow-Dot dot"></div>
                  </div>
                </Col>
              </Row>

              <AdnTable
                key={"previous"}
                style={{ paddingTop: "5px" }}
                columns={columns}
                data={dataPrevious}
                currentPage={currentPagePrevious}
                totalRecords={totalRecordsPrevious}
                handleChange={handleOrderListPrevious}
                handleChangePage={handleChangePagePrevious}
                expandable={(record) => {
                  return (
                    <>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          style={{ fontWeight: "bold", marginRight: "5px" }}
                        >
                          {t("followUpEventForm.status.notes")}
                        </label>
                        <Input
                          type="text"
                          defaultValue={record.note}
                          onChange={(event) => {
                            record.note = event.target.value;
                          }}
                          onBlur={() => {
                            onUpdateEmployeeFollowUpNotes(record);
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </>
                  );
                }}
                rowClassName={(record, index) => setBackgroundColor(record)}
              />
            </>
          ) : selectedMonth === MonthlyStatus.Current ? (
            <>
              <Row justify="space-between">
                {/* Button that notifies the people that have something assigned in the current month */}
                <Row align="middle">
                  {isUserRH ? (
                    <Popconfirm
                      title={t(
                        "followUpEventForm.confirmations.notifyAllAssigned"
                      )}
                      onConfirm={handleNotifyAssignedPeople}
                      okText={t("followUpEventForm.buttons.yes")}
                      cancelText={t("followUpEventForm.buttons.no")}
                    >
                      <Button
                        className="notifyFollowUpEvent adn-primary-button"
                        type="submit"
                      >
                        <BellOutlined /> {t("followUpEventForm.buttons.notify")}
                      </Button>
                    </Popconfirm>
                  ) : (
                    <Button
                      className="notifyFollowUpEvent adn-primary-button-disabled"
                      type="submit"
                      disabled="true"
                    >
                      <BellOutlined /> {t("followUpEventForm.buttons.notify")}
                    </Button>
                  )}
                </Row>

                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                  xl={{ span: 20 }}
                  xxl={{ span: 20 }}
                >
                  <Row gutter={12} className="filterRow" justify="end">
                    <Col
                      className="monthlyNameFilter filter-item"
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <AdnAutoComplete
                        placeholder={t(
                          "followUpEventForm.placeholders.employeeName"
                        )}
                        handleSearch={(value) =>
                          handleEmployeeSearchChange(value, "current")
                        }
                        resultList={[]}
                        defaultValue={employeeNameCurrent}
                        valueId="name"
                        allowClear={true}
                      />
                    </Col>
                    <Col
                      className="monthlyAssignedFilter filter-item"
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <AdnDropdown
                        name="assignedToName"
                        placeholder={t(
                          "followUpEventForm.placeholders.assignedToName"
                        )}
                        options={assignedToList}
                        allowClear={true}
                        valueIsId={false}
                        defaultValue={
                          assignedToNameCurrent !== ""
                            ? assignedToNameCurrent
                            : null
                        }
                        handleChange={(value) =>
                          handleAssignedToChange(value, "current")
                        }
                      />
                    </Col>
                    <Col
                      className="monthlyManagerFilter filter-item"
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <AdnDropdown
                        name="managerName"
                        placeholder={t(
                          "followUpEventForm.placeholders.managerName"
                        )}
                        options={managersList}
                        allowClear={true}
                        valueIsId={false}
                        defaultValue={
                          managerNameCurrent !== "" ? managerNameCurrent : null
                        }
                        handleChange={(value) =>
                          handleManagerChange(value, "current")
                        }
                      />
                    </Col>
                    <Col
                      className="monthlyEventTypeFilter filter-item"
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <AdnDropdown
                        name="eventType"
                        placeholder={t(
                          "followUpEventForm.placeholders.eventType"
                        )}
                        options={eventTypeOptions}
                        allowClear={true}
                        defaultValue={
                          eventTypeCurrent !== "" ? eventTypeCurrent : null
                        }
                        handleChange={(value) =>
                          handleEventTypeChange(value, "current")
                        }
                      />
                    </Col>
                    <Col
                      className="monthlyEventStatusFilter filter-item"
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <AdnDropdown
                        name="eventStatus"
                        placeholder={t(
                          "followUpEventForm.placeholders.eventStatus"
                        )}
                        options={followUpEventStatuOptions}
                        allowClear={true}
                        defaultValue={
                          statusCurrent !== "" ? statusCurrent : null
                        }
                        handleChange={(value) =>
                          handleEventStatusChange(value, "current")
                        }
                      />
                    </Col>
                    <Col
                      className="monthlyEventStatusFilter filter-item"
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                      xl={{ span: 4 }}
                      xxl={{ span: 4 }}
                    >
                      <AdnDropdown
                        name="contractType"
                        placeholder={t(
                          "followUpEventForm.placeholders.contractType"
                        )}
                        options={contractTypeOptions}
                        allowClear={true}
                        valueIsId={false}
                        defaultValue={
                          contractTypeCurrent !== ""
                            ? contractTypeCurrent
                            : null
                        }
                        handleChange={(value) =>
                          handleContractTypeChange(value, "current")
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row justify="end" style={{ gap: 12 }}>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.resigned")}
                    <div className="employee-resigned-Dot dot"></div>
                  </div>
                </Col>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.criticalSituation")}
                    <div className="employee-criticalSituation-Dot dot"></div>
                  </div>
                </Col>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.lateEvent")}
                    <div className="lateEventRow-Dot dot"></div>
                  </div>
                </Col>
              </Row>

              <AdnTable
                key={"current"}
                style={{ paddingTop: "5px" }}
                columns={columns}
                data={dataCurrent}
                currentPage={currentPageCurrent}
                totalRecords={totalRecordsCurrent}
                handleChange={handleOrderListCurrent}
                handleChangePage={handleChangePageCurrent}
                expandable={(record) => {
                  return (
                    <>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          style={{ fontWeight: "bold", marginRight: "5px" }}
                        >
                          {t("followUpEventForm.status.notes")}
                        </label>
                        <Input
                          type="text"
                          defaultValue={record.note}
                          onChange={(event) => {
                            record.note = event.target.value;
                          }}
                          onBlur={() => {
                            onUpdateEmployeeFollowUpNotes(record);
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </>
                  );
                }}
                rowClassName={(record, index) => setBackgroundColor(record)}
              />
            </>
          ) : (
            <>
              <Row gutter={12} className="filterRow" justify="end">
                <Col
                  className="monthlyNameFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnAutoComplete
                    placeholder={t(
                      "followUpEventForm.placeholders.employeeName"
                    )}
                    handleSearch={(value) =>
                      handleEmployeeSearchChange(value, "next")
                    }
                    resultList={[]}
                    defaultValue={employeeNameNext}
                    valueId="name"
                    allowClear={true}
                  />
                </Col>
                <Col
                  className="monthlyAssignedFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="assignedToName"
                    placeholder={t(
                      "followUpEventForm.placeholders.assignedToName"
                    )}
                    options={assignedToList}
                    allowClear={true}
                    valueIsId={false}
                    defaultValue={
                      assignedToNameNext !== "" ? assignedToNameNext : null
                    }
                    handleChange={(value) =>
                      handleAssignedToChange(value, "next")
                    }
                  />
                </Col>
                <Col
                  className="monthlyManagerFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="managerName"
                    placeholder={t(
                      "followUpEventForm.placeholders.managerName"
                    )}
                    options={managersList}
                    allowClear={true}
                    valueIsId={false}
                    defaultValue={
                      managerNameNext !== "" ? managerNameNext : null
                    }
                    handleChange={(value) => handleManagerChange(value, "next")}
                  />
                </Col>
                <Col
                  className="monthlyEventTypeFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="eventType"
                    placeholder={t("followUpEventForm.placeholders.eventType")}
                    options={eventTypeOptions}
                    allowClear={true}
                    defaultValue={eventTypeNext !== "" ? eventTypeNext : null}
                    handleChange={(value) =>
                      handleEventTypeChange(value, "next")
                    }
                  />
                </Col>
                <Col
                  className="monthlyEventStatusFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="eventStatus"
                    placeholder={t(
                      "followUpEventForm.placeholders.eventStatus"
                    )}
                    options={followUpEventStatuOptions}
                    allowClear={true}
                    defaultValue={statusNext !== "" ? statusNext : null}
                    handleChange={(value) =>
                      handleEventStatusChange(value, "next")
                    }
                  />
                </Col>
                <Col
                  className="monthlyEventStatusFilter filter-item"
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  xl={{ span: 4 }}
                  xxl={{ span: 4 }}
                >
                  <AdnDropdown
                    name="contractType"
                    placeholder={t(
                      "followUpEventForm.placeholders.contractType"
                    )}
                    options={contractTypeOptions}
                    allowClear={true}
                    valueIsId={false}
                    defaultValue={
                      contractTypeNext !== "" ? contractTypeNext : null
                    }
                    handleChange={(value) =>
                      handleContractTypeChange(value, "next")
                    }
                  />
                </Col>
              </Row>

              <Row justify="end" style={{ gap: 12 }}>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.resigned")}
                    <div className="employee-resigned-Dot dot"></div>
                  </div>
                </Col>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.criticalSituation")}
                    <div className="employee-criticalSituation-Dot dot"></div>
                  </div>
                </Col>
                <Col>
                  <div className="checkbox-label">
                    {t("followUpEventForm.status.lateEvent")}
                    <div className="lateEventRow-Dot dot"></div>
                  </div>
                </Col>
              </Row>

              <AdnTable
                key={"next"}
                style={{ paddingTop: "5px", justify: "center" }}
                columns={columns}
                data={dataNext}
                currentPage={currentPageNext}
                totalRecords={totalRecordsNext}
                handleChange={handleOrderListNext}
                handleChangePage={handleChangePageNext}
                expandable={(record) => {
                  return (
                    <>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          style={{ fontWeight: "bold", marginRight: "5px" }}
                        >
                          {t("followUpEventForm.status.notes")}
                        </label>
                        <Input
                          type="text"
                          defaultValue={record.note}
                          onChange={(event) => {
                            record.note = event.target.value;
                          }}
                          onBlur={() => {
                            onUpdateEmployeeFollowUpNotes(record);
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </>
                  );
                }}
                rowClassName={(record, index) => setBackgroundColor(record)}
              />
            </>
          )}
        </AdnCard>
        <Modal
          title={t("followUpEventForm.modals.cancelFollowUpEvent")}
          open={cancelEventVisible}
          onOk={form.submit}
          onCancel={() => {
            form.resetFields();
            setCancelEventVisible(false);
          }}
          footer={[
            <Button
              className="adn-outlined-button"
              key="back"
              onClick={() => setCancelEventVisible(false)}
            >
              {t("followUpEventForm.buttons.back")}
            </Button>,
            <Button
              key="ok"
              type="primary"
              onClick={form.submit}
              className="adn-primary-button primary-cancel"
            >
              <span style={{ color: "red" }}>
                {t("followUpEventForm.buttons.cancelEvent")}
              </span>
            </Button>,
          ]}
        >
          <Form
            form={form}
            name="form_in_modal"
            layout="vertical"
            onFinish={handleCancelEventFinish}
          >
            <p> {t("followUpEventForm.confirmations.cancelEvent")} </p>
            <p> {t("followUpEventForm.confirmations.cancelEventNotes")} </p>
            <AdnInput
              name={"note"}
              placeholder={t("followUpEventForm.placeholders.insertNotes")}
              maxLength={500}
            />
          </Form>
        </Modal>
        <Modal
          title={t("followUpEventForm.modals.undoneFollowUpEvents")}
          open={unresolvedModalVisible}
          onOk={() => {
            confirmAssignPerson(eventEmployeeId, eventAssignedToId);
            setUnresolvedModalVisible(false);
          }}
          okText={t("followUpEventForm.buttons.yes")}
          onCancel={() => {
            setUnresolvedModalVisible(false);
          }}
          cancelText={t("followUpEventForm.buttons.no")}
        >
          {t("followUpEventForm.confirmations.previousUndoneEvents")} <br />
          <Link
            to={AppRoutes.consultantById.createPath(
              unresolvedEmployee.employeeId
            )}
          >
            {unresolvedEmployee.employeeName}
          </Link>
          <br />
          <br />
          <u>{t("followUpEventForm.labels.listOfEvents")}</u>
          <br />
          {unresolvedEmployee.listOfEvents &&
            unresolvedEmployee.listOfEvents.map((name) => {
              return (
                <>
                  <span>{name}</span>
                  <br />
                </>
              );
            })}
          <br />
          <u>{t("followUpEventForm.confirmations.assignEventAnyway")}</u>
        </Modal>
      </div>
    </>
  );
};
